import(/* webpackMode: "eager", webpackExports: ["CallToAction"] */ "/opt/build/repo/app/components/home-sections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/opt/build/repo/components/common/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDemoSection"] */ "/opt/build/repo/components/common/screens.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UseCasesSection"] */ "/opt/build/repo/components/common/usecases.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShowcase"] */ "/opt/build/repo/components/home/app-showcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/home/features-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformIntelligence"] */ "/opt/build/repo/components/home/platform-intelligence.tsx");
